import { gettext } from '@eventbrite/i18n';
import React from 'react';

export type RefundPolicyProps = {
    isEnableRetainFeeActive: boolean;
    isPaidEvent: boolean;
    isRefundRequestAllowed: boolean;
    refundPolicyDescription: string;
    refundPolicyIsNoRefunds: boolean;
};

export const RefundPolicy = ({
    isEnableRetainFeeActive,
    isPaidEvent,
    isRefundRequestAllowed,
    refundPolicyDescription,
    refundPolicyIsNoRefunds,
}: RefundPolicyProps) => {
    if (!isPaidEvent) {
        return null;
    }
    return (
        <>
            {refundPolicyDescription && (
                <>
                    <h3 className="label-primary normal-case l-mar-bot-2">
                        {gettext('Refund policy')}
                    </h3>
                    <div
                        className="event-details__data"
                        data-automation="refund-policy"
                    >
                        {/* Movida peligrosa
                     <p>${mark_safe(props['refundPolicyDescription'])}</p>
                     */}
                        <p>{refundPolicyDescription}</p>
                        {isEnableRetainFeeActive &&
                            !refundPolicyIsNoRefunds && (
                                <p>
                                    {gettext(
                                        "Eventbrite's fee is nonrefundable.",
                                    )}
                                </p>
                            )}
                    </div>
                </>
            )}
            {isEnableRetainFeeActive &&
                !refundPolicyDescription &&
                (isRefundRequestAllowed ? (
                    <>
                        <h3 className="label-primary normal-case l-mar-bot-2">
                            {gettext('Refund policy')}
                        </h3>
                        <div
                            className="event-details__data"
                            data-automation="refund-policy"
                        >
                            <p>
                                {gettext(
                                    'Contact the organizer to request a refund.',
                                )}
                            </p>
                            <p>
                                {gettext("Eventbrite's fee is nonrefundable.")}
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <h3 className="label-primary normal-case l-mar-bot-2">
                            {gettext('Refund policy')}
                        </h3>
                        <div
                            className="event-details__data"
                            data-automation="refund-policy"
                        >
                            <p>{gettext('No Refunds')}</p>
                        </div>
                    </>
                ))}
        </>
    );
};
